module.exports = __webpack_public_path__ + "img/cal.adc31aa1.jpg";